import React from 'react';

export default function StatImage({ srcImage, className }) {
  return <img src={srcImage} alt='' className={className} />;
}
